import { render, staticRenderFns } from "./treadsInfo.vue?vue&type=template&id=b9298d04"
import script from "./treadsInfo.vue?vue&type=script&lang=js"
export * from "./treadsInfo.vue?vue&type=script&lang=js"
import style0 from "./treadsInfo.vue?vue&type=style&index=0&id=b9298d04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports